<template>
  <div v-if="number && label" class="stat-card">
    <div class="stat-card__number">{{ formatNumber(number) }} kr</div>
    <div class="stat-card__label">{{ label }}</div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  number?: number;
  label?: string;
}>();

const numberFormatter = new Intl.NumberFormat('sv-SE');
const formatNumber = (value: number) => numberFormatter.format(value);
</script>
